export default {
  name: "testimonials",
  components: {},
  props: [],
  data() {
    return {
      centeredTestimonalIndex: 1,
      testimonials: [
        {
          name: "Patrick Corrigan",
          title: "CEO How Are You",
          text:
            "Idea 41 built our minimalist mindfulness application. Using their service allowed us to launch a much better product than we could have on our own. They helped us to refine the feature set and develop the simplest product we needed. Our customers love it and we continue working with Idea 41 iterating on their feedback."
        },
        {
          name: "Patrick Corrigan",
          title: "CEO of RemoteDeveloper.io",
          text:
            "Working with Idea 41 to build our product saved us time and money. Their experience in building a product from start to finish is priceless. They took care of the whole process from product design and user experience to engineering and deployment. They delivered a product that will scale for us using a serverless architecture."
        },
        {
          name: "Liam English",
          title: "CEO of Bluemetrix",
          text: "Work currently in progress"
        }
      ]
    };
  },
  computed: {},
  mounted() {},
  methods: {
   clicked() {
    console.log('Clicked');
  }
  }
};
